import { render } from "./LoadingForms.vue?vue&type=template&id=5cb9f04f"
import script from "./LoadingForms.vue?vue&type=script&lang=js"
export * from "./LoadingForms.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Proyectos\\ERP ELECTRONICO\\ERP-FRONT\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__